
<header class="customnavcolor customheader">
  <div class="container-fluid max-container">
    <div class="row">
      <div class="col-md-3 col-xl-2 max-logo">
        <img id="logo" alt="Oregon PERS logo" src="assets/images/logo-no-text.svg">
      </div>
      <div class="col">
        <h1 class="header-title">Employer Rate Projection Tool</h1>
      </div>
    </div>
  </div>
</header>

<main id="main" class="container-fluid max-container">
  <div id="content">
      <router-outlet></router-outlet>
  </div>
</main>

<footer>
  <div class="container-fluid max-container">
    <p>Oregon Public Employees Retirement System</p>
    <a href="mailto:actuarial.services@pers.oregon.gov">Contact PERS Actuarial Services</a>
  </div>
</footer>

<ng-template #mymodal let-modal role="dialog" aria-labelledby="dialog1Title">
  <div class="modal-header">
    <h2 id=""dialog1Title class="modal-title" id="modal-basic-title">Employer Rate Projection Tool</h2>
  </div>
  <div class="modal-body">
    <p>Users of this tool acknowledge that the data presented here is for rough planning purposes only and that the projections contained herein should not be relied upon to make future budget or staffing decisions.</p>
    <p>This tool should not be considered a substitute for an actuarial calculation. Projections in this tool are based on system-wide actuarial methods and assumptions and individual employer experience will vary. Future changes in actuarial methods or assumptions will affect these results.</p>
    <p>More information is available at the link below.<br/> <a href="https://www.oregon.gov/pers/EMP/Documents/User Guide.pdf" target="_blank">Employer Rate Projection Tool – User Guide</a></p>
  </div>
  <div class="modal-footer">
    <button type="button" class="button" (click)="modal.close('Save click'); focusFirst()">Acknowledge</button>
    <a type="button" class="button-secondary" href="https://www.oregon.gov/pers/EMP/Pages/Employer-Rate-Projection-Tool.aspx">Cancel and Close the tool</a>
  </div>
</ng-template>
